export default __webpack_public_path__ + "static/dog-lick-affbc745af9f1687f3483bdcbccfc300.gif";